<template>
  <v-menu
    offset-x
    right
    :max-width="250"
    :nudge-width="100"
    v-model="isOpenMenu"
    transition="slide-x-transition"
  >
    <template v-slot:activator="{ on }">
      <v-hover v-slot:default="{ hover }">
        <div v-on="on" class="d-inline-block">
          <v-btn
            v-on="on"
            icon
            small
            class="mx-1"
            :color="hover ? 'secondary' : isDark ? 'blue-grey darken-1' : 'blue-grey'"
          >
            <v-icon>
              mdi-information-outline
            </v-icon>
          </v-btn>
        </div>
      </v-hover>
    </template>
    <v-card>
      <v-list dense>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-uppercase primary--text">
              Estatus
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-tooltip>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="resetConnections" icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-reload</v-icon>
                </v-btn>
              </template>
              <span>Reconectar</span>
            </v-tooltip>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <v-divider class="my-0 py-0"></v-divider>

      <v-list dense>
        <template v-if="isAgent && hasRTC && AutoAnswerCalls">
          <v-list-item>
            <v-list-item-icon class="mr-6">
              <v-icon>mdi-phone-check</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                <!-- {{ isConnectedToSIP ? "Conectado" : "Desconectado" }} -->
                Teléfono
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-chip small v-if="isLoading" color="warning">
                Cargando
              </v-chip>
              <v-chip v-else small>{{ connectionStatus.extension.status }}</v-chip>
            </v-list-item-action>
          </v-list-item>

          <v-list-item>
            <v-list-item-icon style="margin-right: 25px">
              <v-icon>mdi-human-queue</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title> Cola </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-for="queueInfo in connectionStatus.queue" :key="queueInfo.queue">
            <v-list-item-content>
              <v-list-item-title class="ml-3">
                {{ queueInfo.queue }}
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-chip small v-if="isLoading" color="warning">
                Cargando
              </v-chip>
              <v-chip v-else small :color="queueInfo.connected ? 'success' : 'default'">
                {{ queueInfo.connected ? "Conectado" : "Desconectado" }}
              </v-chip>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import { getOwnQueues } from "@/services/utils";

export default {
  data: () => ({
    isLoading: false,
    isOpenMenu: false,
    myQueues: [],
    connectionStatus: {
      extension: {},
      queue: [],
    },
  }),

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },

    isDark() {
      return this.$vuetify.theme.dark;
    },

    isAgent() {
      return this.ProfileInfo?.role_id == 3;
    },

    ProfileInfo() {
      return this.$store.getters["passport/CURRENT_USER"];
    },

    hasRTC() {
      return !!this.ProfileInfo.web_rtc;
    },

    AutoAnswerCalls() {
      return !!this.ProfileInfo.web_rtc?.auto_answer;
    },

    IsBreakActive() {
      return this.$store.getters["breaks/GET_IS_BREACK_ACTIVE"];
    },
  },

  created() {
    this.getMyQueues();
  },

  watch: {
    isOpenMenu(val) {
      if (val) this.getConnectionStatus();
    },
  },

  methods: {
    resetConnections() {
      this.$store.dispatch("dialer/TOGGLE_IS_CONNECTED");
      this.$store.dispatch("dialer/TOGGLE_IS_CONNECTED");
      setTimeout(() => {
        this.connectPlant(this.ProfileInfo.extension);
      }, 2000);
    },

    async GetProfileInfo() {
      try {
        await this.$store.dispatch("passport/ACTIVE_USER");
      } catch (error) {
        console.error("error al obtener perfil", error);
      }
    },

    async connectPlant(extension) {
      this.isLoadingConnect = true;

      try {
        const res = await this.$store.dispatch(
          "passport/RESET_CONNECTION_AGENT",
          extension
        );

        if (res.status === 200) {
          for (const client of res.data) {
            switch (client.codigo) {
              case "Added":
                this.$snotify.success(`${client.message}`, `Cola ${client.queue}`);

                break;

              case "Command":
                this.$snotify.error(`Cola ${client.queue}: ${client.message}`, "¡Error!");

                break;

              case "Removed":
                this.$snotify.success(`${client.message}`, `Cola ${client.queue}`);

                break;
            }
          }
          this.GetProfileInfo();
        }
      } catch (error) {
        // console.error(error);
        this.$snotify.error("Error al conectar a planta.", "Error 500");
      } finally {
        this.isLoadingConnect = false;
      }
    },

    async getMyQueues() {
      try {
        const { queues } = await getOwnQueues();
        this.myQueues = queues;

        this.connectionStatus.queue = queues.map((number) => ({
          queue: number,
          connected: false,
        }));
      } catch (error) {
        console.log("error getting queues", error);
      }
    },

    async getConnectionStatus() {
      this.isLoading = true;
      try {
        const res = await PbxHttpClient.get("/manager/extension_new_details", {
          params: { extension: this.ProfileInfo.extension },
        });
        this.connectionStatus.extension = res.data.data;

        const { queues } = await getOwnQueues();
        const queueStatuses = [];
        for (const queue of queues) {
          const res = await PbxHttpClient.get("/admin/connection_queue_status", {
            params: { extension: this.ProfileInfo.extension, queue },
          });

          const queueInfo = {
            queue: res.data.data.queue,
            connected: res.data.data.status === "1",
          };
          queueStatuses.push(queueInfo);
        }
        this.connectionStatus.queue = queueStatuses;
      } catch (err) {}
      this.isLoading = false;
    },
  },
};
</script>

<style></style>
